module.exports = __webpack_public_path__ + "img/fixed_1.725990d3.jpg";